import * as React from 'react';
import checkmark from '../../../../assets/images/static_pages/green_checkmark.svg';

interface UpgradeColumnFeaturesProps {
  featureSections: Record<string, any>;
}

export const UpgradeColumnFeatures = ({ featureSections }: UpgradeColumnFeaturesProps) => {
  const sections = featureSections.map((section, idx) => {
    const features = section.features.map((feature) => {
      const [show, setShow] = React.useState(false);
      const handleMouseEnter = () => setShow(true);
      const handleMouseLeave = () => setShow(false);
      const hoverStateClass = `hover-state ${show ? '' : 'hide'}`;
      return (
        <tr key={feature.body + idx}>
          <td className="symbol">
            <img className="complete" src={checkmark} alt="checkmark" style={{ marginRight: '10px' }} />
          </td>
          <td>
            <span className={`fsz-14 ${section.bold ? 'bold' : ''}`}>{feature.body}</span>
            {
              feature.hover && (
                <>
                  &nbsp;
                  <span
                    className="orange info-icon"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    ⓘ
                  </span>
                  <span className={hoverStateClass}>
                    <span className="bold-600">{feature.hover.header}</span>
                    <br />
                    <p>{feature.hover.body}</p>
                  </span>
                </>
              )
            }
          </td>
        </tr>
      );
    });

    return (
      <div className="mb-10" key={section.header}>
        <p className="fsz-13 mt-15 mb-10 bold-600" style={section.style}>{section.header}</p>
        <table>
          <tbody>{features}</tbody>
        </table>
      </div>
    );
  });

  return <>{sections}</>;
};
